function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useTheme } from "@emotion/react";
import Fade from "@mui/material/Fade";
import { useToggle } from "@react-hookz/web";
import React from "react";
import { SwitchTransition } from "react-transition-group";
import { useSdkContext } from "~/components/contexts";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { notEmpty } from "~/lib/utils";
import { getNewsletterTitle } from "./helpers";
import { useAction } from "./hooks";
var IconCheckboxCheckedBlack = function IconCheckboxCheckedBlack(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17 1v16H1V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.692 12.115.004-.004-.004.004ZM14.332 5l.668.625-7.56 7.074-.338.301L3 9.162l.668-.625 3.442 3.22L14.332 5Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};
IconCheckboxCheckedBlack.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconCheckboxChecked = function IconCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z",
    fill: "#4585FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4585FF",
    d: "M17 1v16H1V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.692 12.115.004-.004-.004.004zM14.332 5l.668.625-7.56 7.074-.338.301L3 9.162l.668-.625 3.442 3.22L14.332 5z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};
IconCheckboxChecked.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconCheckboxCheckedOff = function IconCheckboxCheckedOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17 1v16H1V1h16zm-1-1H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z",
    fill: "#CCC",
    fillRule: "evenodd"
  }));
};
IconCheckboxCheckedOff.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};
import { ActionContainer, AgreementCheckboxContainer, AgreementContainer, AgreementDescription, Container, Description, DescriptionContainer, Summary, SummaryContainer, SummaryLine, TermAndConditionContainer, TermAndConditionLink, Title, TitleContainer } from "./styles";
export const SignUpNewsletter = ({
  isDisableSignupButtonMouseOver = false,
  isShowOverlaySignUp = false,
  onSuccess,
  ...props
}) => {
  var _theme$signUpNewslett2, _newsletterItemForDis, _theme$signUpNewslett3, _newsletterItemForDis2;
  const {
    handleRoutePush,
    handleTrackGA4,
    user
  } = useSdkContext();
  const isLoggedIn = notEmpty(user === null || user === void 0 ? void 0 : user.useremail);
  const theme = useTheme();
  const [isAgreedReceiveMarketing, setIsAgreedReceiveMarketing] = useToggle(false);
  const {
    campaignName,
    newsletterItemForDisplay,
    titleComponent
  } = useNewsletterContext();
  const renderCheckbox = () => {
    if (isAgreedReceiveMarketing) {
      var _theme$signUpNewslett;
      return (theme === null || theme === void 0 || (_theme$signUpNewslett = theme.signUpNewsletter) === null || _theme$signUpNewslett === void 0 ? void 0 : _theme$signUpNewslett.checkboxStyle) === "black" ? /*#__PURE__*/React.createElement(IconCheckboxCheckedBlack, null) : /*#__PURE__*/React.createElement(IconCheckboxChecked, null);
    }
    return /*#__PURE__*/React.createElement(IconCheckboxCheckedOff, {
      "data-qa": "render-checkbox"
    });
  };
  const {
    actionComponent,
    handleRenderActionComponent
  } = useAction({
    isAgreedReceiveMarketing,
    isDisableSignupButtonMouseOver,
    isShowOverlaySignUp,
    onSuccess
  });
  const computedNewsletterTitle = getNewsletterTitle(newsletterItemForDisplay);
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "sign-up-newsletter"
  }), (theme === null || theme === void 0 ? void 0 : theme.hasSummaryLine) && /*#__PURE__*/React.createElement(SummaryLine, null), (theme === null || theme === void 0 || (_theme$signUpNewslett2 = theme.signUpNewsletter) === null || _theme$signUpNewslett2 === void 0 ? void 0 : _theme$signUpNewslett2.hasSummary) && /*#__PURE__*/React.createElement(SummaryContainer, null, /*#__PURE__*/React.createElement(Summary, null, newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 || (_newsletterItemForDis = newsletterItemForDisplay.summary) === null || _newsletterItemForDis === void 0 ? void 0 : _newsletterItemForDis.text)), (theme === null || theme === void 0 ? void 0 : theme.hasTitle) && computedNewsletterTitle && /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(Title, null, titleComponent !== null && titleComponent !== void 0 ? titleComponent : computedNewsletterTitle)), (theme === null || theme === void 0 || (_theme$signUpNewslett3 = theme.signUpNewsletter) === null || _theme$signUpNewslett3 === void 0 ? void 0 : _theme$signUpNewslett3.hasDescription) && /*#__PURE__*/React.createElement(DescriptionContainer, null, /*#__PURE__*/React.createElement(Description, null, newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 || (_newsletterItemForDis2 = newsletterItemForDisplay.description) === null || _newsletterItemForDis2 === void 0 ? void 0 : _newsletterItemForDis2.text)), !isLoggedIn && /*#__PURE__*/React.createElement(AgreementContainer, null, /*#__PURE__*/React.createElement(AgreementDescription, null, `By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here`), /*#__PURE__*/React.createElement(AgreementCheckboxContainer, {
    onClick: setIsAgreedReceiveMarketing
  }, renderCheckbox())), /*#__PURE__*/React.createElement(SwitchTransition, {
    mode: "out-in"
  }, /*#__PURE__*/React.createElement(Fade, {
    key: actionComponent,
    timeout: 500
  }, /*#__PURE__*/React.createElement(ActionContainer, null, handleRenderActionComponent()))), /*#__PURE__*/React.createElement(TermAndConditionContainer, null, "By registering, you agree to our", /*#__PURE__*/React.createElement(TermAndConditionLink, {
    href: "/terms-conditions",
    onClick: event => {
      event.preventDefault();
      handleTrackGA4({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: campaignName !== null && campaignName !== void 0 ? campaignName : "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      });
      void handleRoutePush("/terms-conditions");
    }
  }, "T&C"), "and", /*#__PURE__*/React.createElement(TermAndConditionLink, {
    href: "/privacy-policy",
    onClick: event => {
      event.preventDefault();
      handleTrackGA4({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: campaignName !== null && campaignName !== void 0 ? campaignName : "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      });
      void handleRoutePush("/privacy-policy");
    }
  }, "Privacy Policy")));
};
SignUpNewsletter.displayName = "SignUpNewsletter";